module.exports = __webpack_public_path__ + "static/warlords_sword-a707d46a37ef3273695abe19675b7e02.jpg";